import PropTypes from 'prop-types';
import { Children, PureComponent } from 'react';
import { fromJS, List } from 'immutable';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Sale... Remove this comment to see the full error message
import cloneElement from 'SalesContentIndexUI/utils/cloneElement';
import SearchResultRecord from 'SalesContentIndexUI/data/records/SearchResultRecord';
import IndexTableRowCellSlot from 'SalesContentIndexUI/slots/IndexTableRowCellSlot';
import IndexTableRowHoverCellSlot from 'SalesContentIndexUI/slots/IndexTableRowHoverCellSlot';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module './In... Remove this comment to see the full error message
import IndexTableCheckboxCell from './IndexTableCheckboxCell';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class IndexTableRow extends PureComponent {
  constructor(...args) {
    super(...args);
    this.getChildMap = () => {
      const {
        children,
        searchResult
      } = this.props;
      let childMap = fromJS({
        cells: List()
      });
      Children.forEach(children, child => {
        const childType = child ? child.type : '';
        switch (childType) {
          case IndexTableRowCellSlot:
          case IndexTableRowHoverCellSlot:
            {
              const childWithProps = cloneElement(child, {
                searchResult
              });
              childMap = childMap.update('cells', cells => cells.push(Object.assign({}, childWithProps, {
                key: `index-table-row-cell-${searchResult.id}-${cells.size}}`
              })));
              break;
            }
          default:
            break;
        }
      });
      return childMap;
    };
    this.handleToggleSelection = () => {
      this.props.toggleRowSelection(this.props.searchResult);
    };
    this.handleClick = e => {
      const {
        onClick
      } = this.props;
      if (onClick) {
        onClick(e);
      }
    };
    this.renderCheckboxCell = () => {
      const {
        selectionData,
        searchResult,
        isPreview,
        isModal,
        disabled
      } = this.props;
      if (isModal) {
        return null;
      } else if (isPreview) {
        return /*#__PURE__*/_jsx("td", {});
      }
      return /*#__PURE__*/_jsx(IndexTableCheckboxCell, {
        contentId: searchResult.get('contentId'),
        selectionData: selectionData,
        toggleSelection: this.handleToggleSelection,
        disabled: disabled
      });
    };
  }
  render() {
    const hasOnClick = Boolean(this.props.onClick);
    return /*#__PURE__*/_jsxs("tr", {
      "data-test-id": "table-row"
      // eslint-disable-next-line no-undefined
      ,
      onClick: hasOnClick ? this.handleClick : undefined,
      children: [this.renderCheckboxCell(), this.getChildMap().get('cells')]
    });
  }
}
IndexTableRow.propTypes = {
  children: PropTypes.any,
  selectionData: PropTypes.object,
  searchResult: PropTypes.instanceOf(SearchResultRecord).isRequired,
  isPreview: PropTypes.bool.isRequired,
  isModal: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  toggleRowSelection: PropTypes.func,
  onClick: PropTypes.func
};
IndexTableRow.defaultProps = {
  isPreview: false,
  isModal: false,
  disabled: false
};